import React, {useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import {useLocation} from 'react-router-dom';

const publications = [
  {
    name: 'FORBES',
    className: 'font-serif tracking-tight'
  },
  {
    name: 'healthline',
    className: 'font-sans font-bold tracking-tight lowercase'
  },
  {
    name: 'WebMD',
    className: 'font-serif font-bold'
  },
  {
    name: 'Men’s Health',
    className: 'font-serif font-bold italic'
  }
];

function PublicationLogos() {
  return (
    <div className="mt-7 text-center">
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-slate-400 grayscale opacity-75">
        {publications.map((publication) => (
          <span
            key={publication.name}
            className={`text-base sm:text-lg ${publication.className}`}
          >
            {publication.name}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function QuizTrustPanel() {
  const {pathname} = useLocation();
  const [mountNode, setMountNode] = useState(null);
  const isMenQuiz = pathname === '/menquiz';

  useEffect(() => {
    let observer;
    let frameId;

    const findAndMount = () => {
      const headingText = isMenQuiz
        ? "Men's health care can be private and convenient."
        : 'GLP-1 meds are popular because they work!';

      const heading = [...document.querySelectorAll('h2')].find(
        (element) => element.textContent.trim() === headingText
      );

      if (!heading) {
        setMountNode(null);
        return;
      }

      const card = heading.closest('[class*="bg-white"]');

      if (!card || !card.parentElement) {
        setMountNode(null);
        return;
      }

      let panelMount = card.parentElement.querySelector(
        '[data-quiz-trust-panel]'
      );

      if (!panelMount) {
        panelMount = document.createElement('div');
        panelMount.dataset.quizTrustPanel = 'true';
        panelMount.className = 'w-full';
        card.parentElement.insertBefore(panelMount, card.nextSibling);
      }

      setMountNode(panelMount);
    };

    frameId = window.requestAnimationFrame(findAndMount);
    observer = new MutationObserver(findAndMount);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      window.cancelAnimationFrame(frameId);
      observer.disconnect();
    };
  }, [isMenQuiz, pathname]);

  if (!mountNode) return null;

  return createPortal(<PublicationLogos />, mountNode);
}